import React, { useState } from "react";
import CancelIcon from "@mui/icons-material/Cancel";
import moment from "moment";
import SwalUI from "../../../components/ui/swal-ui/swal-ui";
import { Modal, Box, TextField } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { Button } from "@mui/material";
import { svCleaningUpdate } from "../../../services/expenses/clean.service";

function FormEditmodal(props) {
  const { openEditModal, setOpenEditModal, setRefreshData, cleanEditdata } =
    props;
  const [editData, setEditData] = useState(cleanEditdata);
  const [isError, setIsError] = useState({
    buy_equipment: false,
    quantity_buy: false,
    date_buy: false,
    expenses: false,
  });

  const handleStartDateChange = (date) => {
    // setSelectedStartDate(date);
    setEditData((prevState) => {
      return { ...prevState, date: date };
    });
  };

  const editValidators = () => {
    let isValid = true;

    let error = {
      ...isError,
      buy_equipment: editData.equipment.trim().length < 1,
      quantity_buy: editData.purchased_count.toString().trim().length < 1,
      date_buy: editData.date.toString().trim().length < 1,
      expenses: editData.expenses.toString().trim().length < 1,
    };
    setIsError(() => error);

    const hasError = Object.values(error).find((err) => err === true);
    if (hasError) isValid = false;

    if (isValid) {
      const formData = new FormData();
      formData.append("id_cleaning", editData.id);
      formData.append("equipment", editData.equipment);
      formData.append(
        "RequisitionDay",
        typeof editData.date === "string"
          ? editData.date
          : moment(editData.date).format("DD/MM/YYYY")
      );
      formData.append("quantity", editData.purchased_count);
      formData.append("totalExpenses", editData.expenses);

      /* Display the key/value pairs*/
      for (var pair of formData.entries()) {
        console.log(pair[0] + ", " + pair[1]);
      }
      // return false;

      svCleaningUpdate(formData).then((res) => {
        console.log(res);
        if (res.status === 200) {
          setRefreshData((prev) => prev + 1);
          SwalUI({
            status: res.data.status,
            //description: res.data.description
          });
          setOpenEditModal(false);
        }
      });
    }
  };
  return (
    <Modal
      open={openEditModal}
      onClose={() => {
        setOpenEditModal(false);
      }}
    >
      <Box
        className="width-modal"
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          bgcolor: "white",
          borderRadius: "10px",
          boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)",
          p: 4,
        }}
      >
        <div className="box-modal-add">
          <div className="justifu-CancelIcon">
            <p
              style={{
                fontSize: "1.75rem",
                fontWeight: 500,
                alignItems: "center",
              }}
            >
              ข้อมูลค่าอุปกรณ์ทำความสะอาด
            </p>
            <button
              onClick={() => {
                setOpenEditModal(false);
              }}
            >
              <CancelIcon className="CancelIcon" />
            </button>
          </div>

          <div className="main-modal">
            <div className="box-modal-1">
              <div className="box-section">
                <p
                  style={{
                    fontWeight: 500,
                    fontSize: "16px",
                    marginBottom: "5px",
                  }}
                >
                  อุปกรณ์ที่ซื้อ
                </p>
                <TextField
                  id="outlined-basic"
                  value={editData.equipment}
                  size="small"
                  // label="หัวข้อ"
                  variant="outlined"
                  style={{ width: "100%" }}
                  error={isError.buy_equipment}
                  onChange={(e) =>
                    setEditData((prevState) => {
                      return { ...prevState, equipment: e.target.value };
                    })
                  }
                />
              </div>
              <div className="box-maintenance">
                <p
                  style={{
                    fontWeight: 500,
                    fontSize: "16px",
                    marginBottom: "5px",
                  }}
                >
                  วันที่ซื้อ
                </p>
                <LocalizationProvider dateAdapter={AdapterMoment}>
                  <DatePicker
                    // label="ปี"
                    inputFormat="DD / MM / YYYY"
                    value={moment(editData.date, "DD/MM/YYYY")}
                    onChange={handleStartDateChange}
                    sx={{ width: "33.33%" }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        sx={{ width: "100%" }}
                        size="small"
                        inputProps={{
                          ...params.inputProps,
                          readOnly: true,
                        }}
                        required
                      />
                    )}
                  />
                </LocalizationProvider>
              </div>
            </div>
            <div className="box-modal-2">
              <div className="box-name-person">
                <p
                  style={{
                    fontWeight: 500,
                    fontSize: "16px",
                    marginBottom: "5px",
                  }}
                >
                  จำนวนที่ซื้อ
                </p>
                <TextField
                  id="outlined-basic"
                  value={editData.purchased_count}
                  size="small"
                  // label="หัวข้อ"
                  InputProps={{
                    inputProps: {
                      pattern: "[0-9]", // Regular expression allowing only numbers
                    },
                  }}
                  onInput={(event) => {
                    const { value } = event.target;
                    const newValue = value.replace(/[^0-9]/g, ""); // Replace non-numeric characters with empty string
                    event.target.value = newValue; // Set the new value
                  }}
                  variant="outlined"
                  style={{ width: "100%" }}
                  error={isError.quantity_buy}
                  onChange={(e) =>
                    setEditData((prevState) => {
                      return { ...prevState, purchased_count: e.target.value };
                    })
                  }
                />
              </div>
              <div className="box-name-person">
                <p
                  style={{
                    fontWeight: 500,
                    fontSize: "16px",
                    marginBottom: "5px",
                  }}
                >
                  ยอดค่าใช้จ่าย
                </p>
                <TextField
                  id="outlined-basic"
                  value={editData.expenses}
                  size="small"
                  // label="หัวข้อ"
                  variant="outlined"
                  style={{ width: "100%" }}
                  error={isError.expenses}
                  onChange={(event) => {
                    const value = event.target.value;
                    if (/^\d*$/.test(value)) {
                      setEditData((prevState) => {
                        return { ...prevState, expenses: value };
                      });
                    }
                  }}
                  inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="Button-save">
          <Button
            variant="contained"
            size="small"
            style={{
              fontSize: "14px",
              background: "#6C5DD3",
              color: "white",
              height: "39px",
              paddingLeft: "1.5rem",
              paddingRight: "1.5rem",
            }}
            className="button-h"
            onClick={editValidators}
          >
            บันทึก
          </Button>
        </div>
      </Box>
    </Modal>
  );
}

export default FormEditmodal;
